"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Booth = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Booth = function Booth() {
  return react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7639 1C19.5215 1 20.214 1.428 20.5528 2.10557L21.7889 4.57771C21.9277 4.85542 22 5.16165 22 5.47214V7C22 8.10457 21.1046 9 20 9C19.6357 9 19.2941 8.90259 18.9999 8.73239L19 15H21C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17V22C21 22.5523 20.5523 23 20 23H4C3.44772 23 3 22.5523 3 22V17C2.44772 17 2 16.5523 2 16C2 15.4477 2.44772 15 3 15H5L5.00108 8.73181C4.74719 8.87889 4.45797 8.97174 4.14926 8.99451L4 9C2.94564 9 2.08183 8.18412 2.00549 7.14926L2 7V5.47625C2 5.16313 2.07352 4.85438 2.21465 4.57486L3.46486 2.09861C3.80502 1.42487 4.49548 1 5.25022 1H18.7639ZM14 18H10C9.44772 18 9 18.4477 9 19C9 19.5523 9.44772 20 10 20H14C14.5523 20 15 19.5523 15 19C15 18.4477 14.5523 18 14 18ZM14 7L13.9945 7.14926C13.9182 8.18412 13.0544 9 12 9C10.9456 9 10.0818 8.18412 10.0055 7.14926L10 7L9.99451 7.14926C9.91817 8.18412 9.05436 9 8 9C7.63568 9 7.29412 8.90259 6.99993 8.73239L7 15H17L17.0011 8.73181C16.7472 8.87889 16.458 8.97174 16.1493 8.99451L16 9C14.8954 9 14 8.10457 14 7Z",
    fill: "currentColor"
  });
};

exports.Booth = Booth;